import React, { useMemo } from 'react';
import { RecordsBadge } from '../../components/recordsBadge';
import { H5, Popover } from '@blueprintjs/core';
import styled from 'styled-components';
import FamilySearchIcon from '../../polotno/ancestry/familySearchIcon';
import AncestryIcon from '../../polotno/ancestry/ancestryIcon';
import { getTemplatePage } from 'editor-utils/template';

const PopoverContent = styled.div`
  padding: 20px;
  dislay: flex;
`;

const DraftSource = props => {
  const showRecordsBadge = useMemo(() => {
    return getTemplatePage(props.template, 'record') != null
  }, [props.template])

  return (
    <>
      {props.item.additionalInfo?.source === "ancestry" && (
        <Popover
          placement="bottom"
          interactionKind="hover"
          className='d-flex'
          minimal
          content={
            <PopoverContent>
              <H5 className='text-ancestry'>{props.item.additionalInfo.treeName}</H5>
              <a href={`https://www.ancestry.com/family-tree/tree/${props.item.additionalInfo.treeId.split(":")[2]}`} target="_blank">Edit in Ancestry.com</a>
              {showRecordsBadge && <RecordsBadge editorItem={props.item} style={{ marginTop: 8 }} />}
            </PopoverContent >
          }
        >
          <button>
            <AncestryIcon />
          </button>
        </Popover>
      )}

      {props.item.additionalInfo?.source === "familysearch" && (
        <Popover
          placement="bottom"
          interactionKind="hover"
          className='d-flex'
          minimal
          content={
            <PopoverContent>
              <H5 className='text-familysearch'>FamilySearch Tree</H5>
              <a href={`https://www.familysearch.org/en/tree/pedigree`} target="_blank">Edit in FamilySearch.org</a>
            </PopoverContent >
          }
        >
          <button>
            <FamilySearchIcon />
          </button>
        </Popover>
      )}
    </>
  );
}

export default DraftSource;
